import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "transition-timeline-button__content-text" }

import { IYearMonth } from '@/coreDomainsModule/date';
import { ForecastForReceiptHeaderKey, TableContentProperty } from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import TableCell from '../TableCell.vue';
import SupplierForecastCreationStatusIcon from './SupplierForecastCreationStatusIcon.vue';
import ForecastRecoveryStatusIcon from './ForecastRecoveryStatusIcon.vue';
import { ForecastForReceiptTableContentViewModel } from './forecastForReceiptTableContentViewModel';
import { computed } from 'vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import ForecastForReceiptRowMenu from './ForecastForReceiptRowMenu.vue';
import StaffFilterRowMenu from './StaffFilterRowMenu.vue';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'ForecastForReceiptTableCell',
  props: {
    header: {},
    headerKey: {},
    item: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    isBold: { type: Boolean },
    forecastStartYearMonth: { default: undefined },
    isChecked: { type: Boolean },
    isCheckedBusinessId: { type: Boolean }
  },
  emits: ["onClickNarrow", "onClickTransitionTimeline", "onClickTransactionList", "onClickDownload", "onClickForecastRequestMail", "onClickEdit", "onClickRemoveFromForecast"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

// props
const props = __props;

// emits
const emits = __emit;

const forecastForReceiptTableContentVM = new ForecastForReceiptTableContentViewModel();

const textAlign = computed(() => {
  if (props.header.key === 'SupplierForecastCreateStatus') {
    return 'center';
  }
  if (props.header.key === 'ForecastForReceiptRecoverStatus' && props.item.forecastForReceiptId) {
    return 'center';
  }
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableCell, {
    class: _normalizeClass([[_unref(forecastForReceiptTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : ''], "table-cell base-table__body--fixed"]),
    style: _normalizeStyle({
      left: _unref(forecastForReceiptTableContentVM).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
    }),
    "text-align": textAlign.value,
    "table-content-property": _ctx.header,
    "tool-tip-value": _unref(forecastForReceiptTableContentVM).displayForecastForReceiptItem(_ctx.headerKey, _ctx.item, _ctx.forecastStartYearMonth),
    "is-highlighted": props.isChecked || props.isCheckedBusinessId
  }, {
    default: _withCtx(() => [
      (_ctx.headerKey === 'SupplierForecastCreateStatus')
        ? (_openBlock(), _createBlock(SupplierForecastCreationStatusIcon, {
            key: 0,
            "is-created": _ctx.item.createdSupplierForecast
          }, null, 8, ["is-created"]))
        : (_ctx.headerKey === 'ForecastForReceiptRecoverStatus' && _ctx.item.forecastForReceiptId)
          ? (_openBlock(), _createBlock(ForecastRecoveryStatusIcon, {
              key: 1,
              "is-recovered": (_ctx.item.recoveredForecastCount ?? 0) >= (_ctx.item.totalForecastCount ?? 0) && (_ctx.item.totalForecastCount ?? 0) > 0
            }, null, 8, ["is-recovered"]))
          : (_ctx.headerKey === 'timelineButton')
            ? (_openBlock(), _createBlock(TextButton, {
                key: 2,
                class: "transition-timeline-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClickTransitionTimeline')))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)('内示遍歴')), 1)
                ], undefined, true),
                _: 1
              }))
            : (_ctx.headerKey === 'ForecastForReceiptRowMenu')
              ? (_openBlock(), _createBlock(ForecastForReceiptRowMenu, {
                  key: 3,
                  onOnClickTransactionList: _cache[1] || (_cache[1] = ($event: any) => (emits('onClickTransactionList'))),
                  onOnSelectMenu: _cache[2] || (_cache[2] = 
        (option) => {
          if (option === 'download') emits('onClickDownload');
          if (option === 'forecastRequestMail') emits('onClickForecastRequestMail');
          if (option === 'edit') emits('onClickEdit');
        }
      )
                }))
              : (_ctx.headerKey === 'ForecastForReceiptEditOption')
                ? (_openBlock(), _createBlock(StaffFilterRowMenu, {
                    key: 4,
                    onOnSelectMenu: _cache[3] || (_cache[3] = 
        (option) => {
          if (option === 'download') emits('onClickDownload');
          // if (option === 'forecastRequestMail') emits('onClickForecastRequestMail');
        }
      )
                  }))
                : (_ctx.headerKey === 'removeFromForecastButton')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 5,
                      class: "remove-from-forecast-button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (emits('onClickRemoveFromForecast')))
                    }, " ✕ "))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 6,
                      class: _normalizeClass(["table-cell-content", { 'table-cell-content': _ctx.isBold }]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (emits('onClickNarrow')))
                    }, _toDisplayString(_unref(forecastForReceiptTableContentVM).displayForecastForReceiptItem(_ctx.headerKey, _ctx.item, _ctx.forecastStartYearMonth)), 3))
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "text-align", "table-content-property", "tool-tip-value", "is-highlighted"]))
}
}

})